import { GoogleGenAI } from "@google/genai";
import { SOLUTIONS } from "../constants";

const getAI = () => {
  const apiKey = process.env.GEMINI_API_KEY;
  if (!apiKey) {
    throw new Error("GEMINI_API_KEY is not set. Please set it in the environment variables.");
  }
  return new GoogleGenAI({ apiKey });
};

const SYSTEM_INSTRUCTION = `
You are an expert customer support chatbot for a premium white-label B2B software provider.
Your goal is to answer questions about our ecosystem of tools (ERP, CRM, RSS, File Management, Analytics, Project Management, Support).

COMPANY CONTEXT:
- We provide high-end, white-labeled software solutions.
- Our core pricing starts at $15/mo with add-ons at $5/mo and setup/installation fee at $50.
- We specialize in industries like D2C, Retail, Healthcare, Construction, and Education.
- Our solutions include: ${SOLUTIONS.map(s => `${s.title}: ${s.description}`).join(", ")}.

GUIDELINES:
- Be professional, helpful, and concise.
- If a user asks for pricing, mention the base $15/mo and $5/mo add-on model.
- If a user asks for "Live Chat" or "Talk to a human", tell them you can connect them to our support team on WhatsApp.
- If you don't know the answer, politely suggest talking to a live agent.
- Keep responses short and scannable (use bullet points if needed).
- Use a helpful, confident tone.
`;

export async function getChatbotResponse(history: { role: "user" | "model"; parts: { text: string }[] }[]) {
  try {
    const ai = getAI();
    const response = await ai.models.generateContent({
      model: "gemini-3-flash-preview",
      contents: history,
      config: {
        systemInstruction: SYSTEM_INSTRUCTION,
        temperature: 0.7,
      },
    });

    return response.text;
  } catch (error) {
    console.error("Gemini Error:", error);
    return "I'm having trouble connecting right now. Would you like to reach out to our team directly on WhatsApp?";
  }
}
